"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymizedOrderForDriver = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const AnonymizedPassenger_1 = require("./AnonymizedPassenger");
const OrderContentLocation_1 = require("./OrderContentLocation");
const OrderCustomLocation_1 = require("./OrderCustomLocation");
const VehicleTypePriceFee_1 = require("./VehicleTypePriceFee");
let AnonymizedOrderForDriver = class AnonymizedOrderForDriver {
    _id;
    departureAt;
    originLocationId;
    destinationLocationId;
    pricingCountryId;
    // TODO @MaxLength
    pickupAddress;
    // TODO @MaxLength
    dropoffAddress;
    passengers;
    vehicles;
    tollPrice = 0;
    tollFee = 0;
    additionalPrice = 0;
    additionalFee = 0;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    discountIds = [];
    vehicleTypesPricesFees = [];
    contentLocations = [];
    customLocations = [];
    acceptedAt = undefined;
    declinedAt = undefined;
    confirmedAt = undefined;
    cancelledAt = undefined;
    driverNote = "";
    customerNote = "";
    paymentMethod = legacy_enums_1.PaymentMethod.Online;
    flightNumber;
    type = legacy_enums_1.OrderType.Private;
    bookingReference;
    get status() {
        if ((0, utils_1.isNotUndefinedOrNull)(this.cancelledAt)) {
            return legacy_enums_1.OrderStatus.Cancelled;
        }
        if ((0, utils_1.isNotUndefinedOrNull)(this.declinedAt)) {
            return legacy_enums_1.OrderStatus.Declined;
        }
        if ((0, utils_1.isNotUndefinedOrNull)(this.acceptedAt)) {
            if ((0, utils_1.isNotUndefinedOrNull)(this.confirmedAt)) {
                return legacy_enums_1.OrderStatus.Confirmed;
            }
            return legacy_enums_1.OrderStatus.Accepted;
        }
        return legacy_enums_1.OrderStatus.Pending;
    }
};
exports.AnonymizedOrderForDriver = AnonymizedOrderForDriver;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], AnonymizedOrderForDriver.prototype, "departureAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "originLocationId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "destinationLocationId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "pricingCountryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "pickupAddress", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "dropoffAddress", void 0);
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => AnonymizedPassenger_1.AnonymizedPassenger),
    __metadata("design:type", Array)
], AnonymizedOrderForDriver.prototype, "passengers", void 0);
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], AnonymizedOrderForDriver.prototype, "vehicles", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForDriver.prototype, "tollPrice", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForDriver.prototype, "tollFee", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForDriver.prototype, "additionalPrice", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForDriver.prototype, "additionalFee", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForDriver.prototype, "pricingCurrency", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value == null ? undefined : value)),
    __metadata("design:type", Array)
], AnonymizedOrderForDriver.prototype, "discountIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => VehicleTypePriceFee_1.VehicleTypePriceFee),
    __metadata("design:type", Array)
], AnonymizedOrderForDriver.prototype, "vehicleTypesPricesFees", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderContentLocation_1.OrderContentLocation),
    __metadata("design:type", Array)
], AnonymizedOrderForDriver.prototype, "contentLocations", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCustomLocation_1.OrderCustomLocation),
    __metadata("design:type", Array)
], AnonymizedOrderForDriver.prototype, "customLocations", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForDriver.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForDriver.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForDriver.prototype, "confirmedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForDriver.prototype, "cancelledAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "driverNote", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "customerNote", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForDriver.prototype, "paymentMethod", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "flightNumber", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForDriver.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForDriver.prototype, "bookingReference", void 0);
exports.AnonymizedOrderForDriver = AnonymizedOrderForDriver = __decorate([
    (0, class_transformer_1.Exclude)()
], AnonymizedOrderForDriver);
//# sourceMappingURL=AnonymizedOrderForDriver.js.map